<section id="sharing-card-list">
  <app-opin-sharing-card
    [data]="sharing"
    [variant]="variant"
    *ngFor="let sharing of sortedSharings"
  ></app-opin-sharing-card>
</section>
